import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/f1-logo-white.svg'


const _hoisted_1 = {
  key: 0,
  class: "leaderboard"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fill" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "content-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fade" }, null, -1)
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "RACE")
], -1)
const _hoisted_9 = { class: "laps" }
const _hoisted_10 = { class: "text-wrapper" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "LAP", -1)
const _hoisted_12 = { class: "current" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, "/", -1)
const _hoisted_14 = { class: "total" }
const _hoisted_15 = { class: "message" }
const _hoisted_16 = { class: "drivers" }
const _hoisted_17 = { key: 1 }

import TowerMessage from "@/components/TowerMessage.vue";
    import TowerDriver from "@/components/TowerDriver.vue";
    import { useState } from "@/composables/useState";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Tower',
  setup(__props) {

    const { useMetadata, useTelemetry } = useState();

    const metadata = useMetadata();
    const telemetry = useTelemetry();

return (_ctx: any,_cache: any) => {
  return (_unref(metadata).liveTimingState && _unref(telemetry).drivers)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["border", 'status-' + _unref(metadata).liveTimingState.TrackStatus.Status])
        }, _hoisted_4, 2),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["border", 'status-' + _unref(metadata).liveTimingState.TrackStatus.Status])
          }, null, 2),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(metadata).liveTimingState.LapCount.CurrentLap), 1),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(metadata).liveTimingState.LapCount.TotalLaps), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(TowerMessage)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(telemetry).drivers, (driver) => {
                return (_openBlock(), _createBlock(TowerDriver, {
                  key: driver.racingNumber,
                  driver: driver
                }, null, 8, ["driver"]))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, "Loading!"))
}
}

})